import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ThemeProvider } from 'styled-components/macro'
import { ErrorBoundary } from 'react-error-boundary'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import BlockDetails from './pages/BlockDetails'
import BlocksList from './pages/BlocksList'
import TokenDetails from './pages/TokenDetails'
import TransactionDetails from './pages/TransactionDetails'
import TransactionsList from './pages/TransactionsList'
import TransactionsForBlock from './pages/TransactionsForBlock'
import NotFound from './pages/NotFound'
import Home from './pages/Home'
import RootStructure from './components/templates/RootStructure'
import { ErrorHandler } from './errorHandler'
import ErrorLayoutHandler from './errorHandler/ErrorLayoutHandler'
import theme from './styles/theme'
import { FallBack } from './providers/FallBack'
import TopAccount from './pages/TopAccount'
import TokenList from './pages/TokenList'
import AccountDetails from './pages/AccountDetails'

const App = () => {
  // NOTE: 프로젝트에 필요한 플러그인 import
  dayjs.extend(relativeTime)
  dayjs.extend(utc)

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <ErrorHandler>
          <RootStructure>
            <ErrorLayoutHandler>
              <ErrorBoundary FallbackComponent={FallBack}>
                <Routes>
                  <Route index element={<Home />} />
                  <Route path="/txs" element={<TransactionsList />} />
                  <Route path="/tx/:txHash" element={<TransactionDetails />} />
                  <Route path="/blocks" element={<BlocksList />} />
                  <Route path="/block/:blockId" element={<BlockDetails />} />
                  <Route path="/block/:blockId/txs" element={<TransactionsForBlock />} />
                  <Route path="/accounts" element={<TopAccount />} />
                  <Route path="/account/:address" element={<AccountDetails />} />
                  <Route path="/token/:address" element={<TokenDetails />} />
                  <Route path="/tokens" element={<TokenList />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </ErrorBoundary>
            </ErrorLayoutHandler>
          </RootStructure>
        </ErrorHandler>
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default App
